import BotoSeguir from 'components/3catinfo/BotoSeguir';

const Tag = (props) => {
    const { tag, segueix, tipologia, estil } = props;
    const getTagSeguir = () => {
        return (
            segueix && (
                <BotoSeguir
                    estil={estil}
                    text={tag.desc}
                    id={tag.idint}
                    textHitAudiencies={tag.desc}
                    tipologia={tipologia}
                    linkTipus={'web_actualitat_seccio'}
                    slug={tag.desc}
                    key={`TAGST${tag.id}`}
                    enviaApi={true}
                    isItemNoti={true}
                />
            )
        );
    };

    return tag ? getTagSeguir() : <></>;
};

export default Tag;

Tag.defaultProps = {
    segueix: true
};
